import { useGitlabInstallation } from '../gitlabInstallationContext';
import { ConfigureGatToken } from './ConfigureGatToken';
import { ConfigurePatToken } from './ConfigurePatToken';

/**
 * Configure-token step dispatcher: renders the GAT single-group step or the PAT
 * multi-URL step per the picker's authType. Only reached in a token flow.
 */
export const ConfigureTokenStep = () => {
  const { authType } = useGitlabInstallation();

  return authType === 'gat' ? <ConfigureGatToken /> : <ConfigurePatToken />;
};
